import React from 'react';

import { Loading } from 'src/components';

import styles from './LoadingView.scss';

const LoadingComponent = () => (
  <div className={styles.loading}>
    <Loading type="spin" color="#e3e3e3" />
  </div>
);

class LoadingView extends React.Component {
  constructor() {
    super();
    // isLoadedOnce: 一度でもローディング状態になったかを判定する
    // 通信状態の状態遷移は、通信前(false) => 通信中(true) => 通信後(false)の流れになるため、
    // 画面初期表示時に初期データ取得までは、ローディング状態にならない。
    // これを解決するために、レンダリング後初回のローディングまではローディング状態にするためにこのフラグを追加。
    // 現状は必ず使われるようになっているため、個別で制御したい場合は別途実装すること
    this.state = { isLoadedOnce: false };
  }
  render() {
    const { children, isLoading } = this.props;
    if (isLoading === true) {
      this.state.isLoadedOnce = true;
    }
    return isLoading || !this.state.isLoadedOnce ? <LoadingComponent /> : <React.Fragment>{children}</React.Fragment>;
  }
}
export default LoadingView;
